<template>
    <p class="mb-0">
        <span :class="['main-text', largeMobileValue ? 'large-main-text' : 'small-main-text']">
            {{ value }}
        </span>

        <span class="small-text d-flex align-self-start" v-html="label"></span>
    </p>
</template>

<script>
export default {
    props: ['value', 'label', 'largeMobileValue'],
}
</script>
